export default __webpack_public_path__ + "static_single_media.d02eb780.png";